/**
 * email-preview.js - A jQuery plugin for previewing emails with a modal and triggering with a button.
 * Created by carterzenk on 10/13/16.
 */
(function($) {

    $.fn.emailPreview = function(options) {

        var defaults = {
            previewUrl: '/email/get',
            noteUrl: '/activity/stream-json?id=',
            dataAttribute: 'email-id',
            buttonClass: 'email-preview-btn',
            modalSize: 'lg',
            noteAttribute: 'note-id',
            loanAttribute: 'loans',
            type: 'email'
        };

        var args = $.extend({}, defaults, options);

        this.each(function() {

            var $previewModal = $(this);

            buildModal();

            $('#content').on('click', '.' + args.buttonClass, function(){
                loadEmail(this);
            });

            function buildModal() {
                var $modalDialog = $('<div class="modal-dialog"></div>');
                var $modalContent = $('<div class="modal-content"></div>');

                $modalDialog.addClass('modal-' + args.modalSize);
                $modalDialog.attr('role', 'dialog');

                $modalContent.append(
                    buildHeader(),
                    buildBody(),
                    buildFooter()
                );

                $modalDialog.append($modalContent);
                $previewModal.append($modalDialog);
                $previewModal.addClass('modal modal-fade')
            }

            function buildHeader() {
                var $modalHeader = $('<div class="modal-header"></div>');
                var $closeButton = $('<button type="button" class="close" data-dismiss="modal">&times;</button>');
                var $modalTitle = $('<h4 id="email-preview-subject" class="modal-title"></h4>');

                $modalHeader.append($closeButton, $modalTitle);

                return $modalHeader;
            }

            function buildBody() {
                var $modalBody = $('<div class="modal-body"></div>');
                var $emailMessage = $('<iframe id="email-preview-message" frameborder="0" width="100%"></iframe>');

                $modalBody.append($emailMessage);

                return $modalBody;
            }

            function buildFooter(){
                var $modalFooter = $('<div class="modal-footer"></div>');
                var $modalCloseButton = $('<button class="btn btn-default" type="button" data-dismiss="modal">Close</button>');

                $modalFooter.append($modalCloseButton);

                return $modalFooter;
            }

            function fillContent(subject, content) {
                var $emailMessage = $('#email-preview-message');
                var iframe = document.getElementById('email-preview-message');

                $('#email-preview-subject').html(subject);
                iframe.contentWindow.contents = content;
                iframe.src = 'javascript:window.contents';

                $emailMessage.addClass('imo-form-iframe');
            }

            function getData(route, callback) {
                $.ajax({
                    url: route,
                    type: 'GET',
                    success: function(data){
                        if (typeof callback === 'function') {
                            callback(data);
                        }
                    }
                });
            }

            function buildUrl($previewButton) {
                var emailId = $previewButton.data(args.dataAttribute);
                var noteId = $previewButton.data(args.noteAttribute);
                var loans = $previewButton.data(args.loanAttribute);
                let url = args.previewUrl + '/' + emailId;

                if (noteId) {
                    defaults.type = 'note';
                    return args.noteUrl + noteId;
                } else {
                    if (loans) {
                        url += '?loans=' + loans;
                    }
                    return url;
                }
            }

            function loadEmail(previewButton) {
                var $previewButton = $(previewButton);
                var route = buildUrl($previewButton);
                var subject = defaults.type === 'note' ? 'title' : 'subject';
                var content = defaults.type === 'note' ? 'notes' : 'message';

                $previewButton.attr('data-loading-text', '<i class="fa fa-spinner fa-pulse fa-fw"></i>');
                $previewButton.button('loading');

                getData(route, function(data) {
                    if (defaults.type === 'note') {
                        data = data.notes[0];
                    }
                    fillContent(data[subject], data[content]);
                    $previewButton.button('reset');
                    $previewModal.modal('show');
                });
            }

        });

        return this;
    };
})(jQuery);